var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9696 33.712C49.0797 32.2425 43.9927 32.2885 38.2344 35.2977C21.531 44.0267 0.940918 63.7885 0.940918 63.7885M52.9696 33.712C60.3634 36.505 63.4321 44.773 58.5647 48.5732C54.5577 51.7017 52.5661 44.4622 52.9696 33.712ZM52.9696 33.712C53.314 24.5337 55.4042 12.7962 59.4764 2.76735M51.357 5.70233L60.8137 1.86065L63.3783 13.0492",
    stroke: "white",
    strokeWidth: 2.71889
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1e0e61ba03fbcef9cd79973d93cb30c8.svg";
export { ForwardRef as ReactComponent };